
import "react-form-wizard-component/dist/style.css";
import React, {useEffect, useRef, useState} from "react";
import { useSelector } from "react-redux";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Button, Modal, Form} from "react-bootstrap";
import '../assets/Styles/SimulationCSS/ZoneManagment.css'
import RCZControlMap from "../components/Controls/mapControlRCZ";
import Select from 'react-select';
import axios from 'axios';

const api_url = 'https://demomicrotransitsimapi.itcurves.us/'; // Replace with your actual API URL
const apiKey = 'h2mUZVfEGuZKVOaR218a3KYwxJr6zyc3'; // Replace with your actual API Key

const ZoneManagment = (props) => {

    const { GlobalASCSData, DispatchVehicleData, FundingSourceData, ZoneVerticesData } = useSelector((store) => store.combinedata);

    const [mapData, setMapData] = useState([{lat:38.737373,lng: 71.34343, Type:"EndDept", name:'Aqib', address:'ANnapolis'}]);
    const handleCLoseZoneManagment = () => {

        props.setZoneManagment(false)

    }


    const [mapOptions, setmapOptions] = useState({
        height: 360,
        heightoffset: 105,
        calculateHeight: true,
        pagination: true,
        mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
        mapDefaultBtns: false,
        mapOptions: {tilt: 47.5, zoom: 15, zone: false}
        
    });

    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [modalContent, setModalContent] = useState('');
    const [folderName, setFolderName] = useState('');
    const [transitName, setTransitName] = useState('');
    const [stopsDataForPopApi, setStopsDataForPopApi] = useState([]);
    const [countyName, setCountyName] = useState('');
    const [stateName, setStateName] = useState('');
    const [populationData, setPopulationData] = useState(null);

    
    const [stops, setStops] = useState([]);
    const [polygonVertices, setPolygonVertices] = useState([]);
    const [insidePolygonStops, setInsidePolygonStops] = useState([]);
    const googleMapComponentRef = useRef(null);



    const onMapDataSave = (updatedPolygonVertices, updatedStops) => {

      console.log('Latest Polygon data', updatedPolygonVertices)
      console.log('Latest Stops Data', updatedStops)
      setPolygonVertices(updatedPolygonVertices);
      
      const insideStops = updatedStops.filter(stop => isPointInPolygon(stop, updatedPolygonVertices));
      setInsidePolygonStops(insideStops);


      
      console.log('Removed Stops Data', insidePolygonStops)


    };


    const isPointInPolygon = (point, polygon) => {
      const x = point[1], y = point[0];
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].lng, yi = polygon[i].lat;
        const xj = polygon[j].lng, yj = polygon[j].lat;
        const intersect = ((yi > y) !== (yj > y)) && 
                         (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    };



    const handleSave = () => {
      if (googleMapComponentRef.current) {
        googleMapComponentRef.current.saveMapData();
      }
    };

  

  



    const handleInputChange = (e) => {
      setName(e.target.value);
    };
  
    const getGTFS = async () => {
      setLoading(true);
      setError(null);
      setModalContent('');
  
      try {
        const apiUrl = `https://transit.land/api/v2/rest/feeds/?apikey=${apiKey}&search=${name}`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          redirect: 'follow'
        });
  
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
  
        const apiData = await response.json();
        const feeds = apiData['feeds'];
  
        if (feeds.length === 0) {
          setModalContent('No GTFS data found');
        } else {
          const url = feeds[0]['urls']['static_current'];
  
          if (!url) {
            setModalContent('GTFS URL not found');
          } else {
            await fetchData(url, false, name);
          }
        }
      } catch (error) {
        setModalContent('An unexpected error occurred');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
  
    const fetchData = async (url, fileAlreadyExists, name) => {
      setLoading(true);
      setError(null);
      setModalContent('');
  
      try {
        const requestParam = {
          url: url,
          fileAlreadyExists: fileAlreadyExists,
          name: name
        };
  
        const response = await fetch(`${api_url}gtfs`, {method: 'POST',headers: {'Content-Type': 'application/json'},body: JSON.stringify(requestParam)});
  
        if (response.ok) {
          const apiData = await response.json();
          console.log(apiData)
          setFolderName(apiData['folder']);
          setTransitName(apiData['transitName']);
          setStopsDataForPopApi(apiData['stops_data']);
          setCountyName(apiData['county_name']);
          setStateName(apiData['state_name']);
          createImageElementandAddToHTML(apiData);
          document.getElementById("searchButton").style.display = "block";
          document.getElementById("populationDistribution").classList.add('populationDistributionButtonDisable');
          getPopulationData();
        } else {
          setModalContent('Error occurred while fetching data');
        }
      } catch (error) {
        setModalContent('An unexpected error occurred');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
  
    const createImageElementandAddToHTML = (apiData) => {
      // Implement your logic for creating an image element and adding it to HTML
    };
  
    const getPopulationData = () => {
      // Implement your logic for fetching population data
    };

    
    

  return (
    <>
        <Modal show={props.showZoneManagment} centered onHide={handleCLoseZoneManagment} dialogClassName="full-width-modal" >
            <Modal.Header closeButton>
                <Modal.Title>Zone Management</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div>
                <input
                  type="text"
                  value={name}
                  onChange={handleInputChange}
                  placeholder="Enter GTFS name"
                />
                <button onClick={getGTFS} disabled={loading}>
                  {loading ? 'Loading...' : 'Get GTFS'}
                </button>

                <button onClick={handleSave}>Save</button>
                {modalContent && <div className="modal">{modalContent}</div>}
                {/* Render other UI components here */}
              </div>
                <Row noGutters>
                    {/* Map Container */}
                    <Col xs={8} style={{ borderRight: '1px solid #ddd' }}>
                        <div style={{ width: '100%', height: '400px' }}>
                            
                            <RCZControlMap ref={googleMapComponentRef} initialStops= {stopsDataForPopApi} center={{ lat: 38.9769396464269, lng: -76.49387978315518 }} zoom={12}  onSave={onMapDataSave}/>
                        </div>
                    </Col>

                    {/* Right Containers */}
                    <Col xs={4} className="d-flex flex-column">
                        <div style={{ flex: 1, borderBottom: '1px solid #ddd' }}>
                            {/* First vertical container */}
                            <p>Container 1</p>
                        </div>
                        <div style={{ flex: 1 }}>
                            {/* Second vertical container */}
                            <p>Container 2</p>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {/* Modal footer content */}
            </Modal.Footer>
        </Modal>
    </>
  );
}

export default ZoneManagment;
